import React, { Component } from "react";
import CartContext from "./CartContext";
import { SideMenu } from "./SideMenu";
import { BiRefresh } from "react-icons/bi";
import { BsFillPencilFill } from "react-icons/bs";
import { MessageBox } from "./MessageBox";
import { LoadSpinner } from "./LoadSpinner";
import DatePicker from "react-date-picker";
import DateTimePicker from "react-datetime-picker";

import {
  OverlayTrigger,
  Stack,
  InputGroup,
  Tooltip,
  Button,
  ButtonToolbar,
  Form,
  Row,
  Col,
  Modal,
  Nav,
  Table,
  Navbar,
} from "react-bootstrap";

export class AccountRevenues extends Component {
  static contextType = CartContext;
  constructor(props) {
    super(props);
    this.state = {
      accountrevenues: [],
      filteredaccountrevenues: [],
      msgboxOpen: false,
      msgboxTitle: "",
      msgboxMessage: "",
      reload: true,
      categories: [],
      dateRange: "Today",
      selectedCategoryId: "",
      startDate: new Date(),
      endDate: new Date(),
    };
  }
  OnCategoryChanged = (e) => {
    this.setState({ selectedCategoryId: e.target.value });
  };
  OnDateRangeChanged = (e) => {
    const { name, value } = e.target;
    this.setState({ dateRange: value }, () => {
      this.GetAccountRevenues();
    });
  };

  GetAccountRevenuesCategorys = () => {
    fetch(
      process.env.REACT_APP_API +
        "Account/GetAccountExpensesCategorys/" +
        this.context.storeId
    )
      .then((response) => response.json())
      .then((data) => {
        if (data.status == 400) {
        } else {
          this.setState({ categories: data }, () => {});
        }
      })
      .catch((error) => {
        console.error("There was an error!", error);
      });
  };
  GetAccountRevenues = () => {
    fetch(
      process.env.REACT_APP_API +
        "Account/GetAccountRevenues/" +
        this.context.storeId +
        "/" +
        this.state.dateRange +
        "/" +
        this.context.GetTicks(this.state.startDate) +
        "/" +
        this.context.GetTicks(this.state.endDate)
    )
      .then((response) => response.json())
      .then((data) => {
        if (data.status == 400) {
        } else {
          this.setState({ accountrevenues: data }, () => {
            this.setState({ filteredaccountrevenues: data });
            this.setState({ reload: false }, () => {
              this.setState({ reload: true });
            });
          });
        }
      })
      .catch((error) => {
        console.error("There was an error!", error);
      });
  };

  CloseMessagBoxCallback = () => {
    this.setState({ msgboxOpen: false });
  };

  OnSaved = () => {
    this.OnRefreshButtonClick();
  };
  OnDeleted = () => {
    this.OnRefreshButtonClick();
  };

  OnRefreshButtonClick = () => {
    this.setState({ accountrevenues: [] }, () => {
      this.GetAccountRevenues();
    });
  };
  ShowMessagBox = (title, message) => {
    this.setState({ msgboxOpen: true });
    this.setState({ msgboxTitle: title });
    this.setState({ msgboxMessage: message });
  };

  OnUpdated = (indexno) => {
    this.OnRefreshButtonClick();
  };

  addModalClose = () => {
    this.setState({ addModalShow: false }, () => {});
    this.OnRefreshButtonClick();
  };

  componentDidMount = () => {
    window.scrollTo(0, 0);
    if (this.state.accountrevenues.length == 0) this.GetAccountRevenues();
    this.GetAccountRevenuesCategorys();
  };

  render() {
    return (
      <>
        <div className="Container-fluid p-0 ">
          {this.state.msgboxOpen === true ? (
            <MessageBox
              open={this.state.msgboxOpen}
              title={this.state.msgboxTitle}
              message={this.state.msgboxMessage}
              callback={this.CloseMessagBoxCallback}
            />
          ) : (
            ""
          )}
          <Navbar className="shadow position-sticky fixed-top py-3 text-black ">
            <h3>
              <b>Account Revenues/Credits</b> &nbsp;
            </h3>
            <Navbar.Collapse className="justify-content-end mx-0 ">
              <Nav>
                <ButtonToolbar className="text-end align-middle">
                  <Button
                    className="mainthemecolor"
                    // onClick={() => this.handleAddAccountRevenues()}
                    onClick={() => this.setState({ addModalShow: true })}
                  >
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      width="26"
                      height="26"
                      fill="currentColor"
                      class="bi bi-plus"
                      viewBox="0 0 16 16"
                    >
                      <path d="M8 4a.5.5 0 0 1 .5.5v3h3a.5.5 0 0 1 0 1h-3v3a.5.5 0 0 1-1 0v-3h-3a.5.5 0 0 1 0-1h3v-3A.5.5 0 0 1 8 4z" />
                    </svg>
                    Add
                  </Button>
                  &nbsp;
                  <Button
                    className="mainthemecolor"
                    size=""
                    onClick={() => this.OnRefreshButtonClick()}
                  >
                    <BiRefresh size="26"></BiRefresh>
                    Refresh
                  </Button>
                  &nbsp;
                  {this.state.addModalShow === true ? (
                    <AccountRevenuesAddOrEditModal
                      show={this.state.addModalShow}
                      Type="Add"
                      onHide={this.addModalClose}
                      categories={this.state.categories}
                    />
                  ) : null}
                </ButtonToolbar>
              </Nav>
            </Navbar.Collapse>
          </Navbar>
          <div className="purposestyle p-2 ">
            {" "}
            <b>Purpose:</b> Use this module to capture all Revenues or inflow to
            the Business account. Every Inflow amount will be associated with an
            account category. The cumulative revenue details can be seen on
            Ledger Module and Report as well.
          </div>
          <div className="bg-light ">
            <Table className="bg-light m-0 p-0">
              <tr className="border-0">
                <td width="20%">
                  <InputGroup className="mb-1">
                    <InputGroup.Text id="basic-addon1">
                      Date Range
                    </InputGroup.Text>
                    <Form.Select
                      value={this.state.dateRange}
                      onChange={(e) => {
                        this.OnDateRangeChanged(e);
                      }}
                    >
                      <option value="Today">Today</option>
                      <option value="Yesterday">Yesterday</option>
                      <option value="Last 3 Days">Last 3 Days</option>
                      <option value="Last 7 Days">Last 7 Days</option>
                      <option value="This Month">This Month</option>
                      <option value="Last Month">Last Month</option>
                      <option value="Last 3 Months">Last 3 Months</option>
                      <option value="All">All</option>
                      <option value="Custom">Custom</option>
                    </Form.Select>
                  </InputGroup>
                </td>
                {this.state.dateRange == "Custom" ? (
                  <>
                    <td>
                      StartDate:{" "}
                      <DateTimePicker
                        onChange={(date) =>
                          this.setState({ startDate: date }, () => {
                            this.GetAccountRevenues();
                          })
                        }
                        value={this.state.startDate}
                        format="dd-MMM-yy HH:mm a"
                      />
                    </td>
                    <td>
                      <Stack direction="horizontal">
                        EndDate:
                        <DateTimePicker
                          onChange={(date) =>
                            this.setState({ endDate: date }, () => {
                              this.GetAccountRevenues();
                            })
                          }
                          value={this.state.endDate}
                          format="dd-MMM-yy hh:mm a"
                        />
                      </Stack>
                    </td>
                  </>
                ) : (
                  <></>
                )}
                <td width="20%">
                  <InputGroup className="mb-1">
                    <InputGroup.Text id="basic-addon1">
                      Category
                    </InputGroup.Text>
                    <Form.Select
                      value={this.state.filterUserTypeName}
                      onChange={(e) => {
                        this.OnCategoryChanged(e);
                      }}
                    >
                      <option value=""></option>
                      {this.state.categories.map((m) => (
                        <>
                          <option value={m.id}>{m.name}</option>
                        </>
                      ))}
                    </Form.Select>
                  </InputGroup>
                </td>
              </tr>
            </Table>
          </div>
          <div>
            <Table border striped className="px-0 bg-white ">
              {window.innerWidth > 900 ? (
                <>
                  <thead className="">
                    <tr className="text-start text-black bg-white border">
                      <th width="5%">#</th>
                      <>
                        <th width="10%" className="text-center">
                          Date{" "}
                        </th>
                        <th width="35%">Details</th>
                        <th width="10%" className="text-center">
                          Category
                        </th>
                        <th width="10%" className="text-center">
                          Received From
                        </th>
                        <th width="10%" className="text-center">
                          Amount
                          <br />
                          Total:
                          {Math.round(
                            this.state.filteredaccountrevenues.reduce(
                              (a, v) => Number((a = a + Number(v.amount))),
                              0
                            ),
                            0
                          )}
                        </th>
                        <th width="10%" className="text-center">
                          CreatedBy
                        </th>
                        <th width="10%" className="text-end">
                          Options
                        </th>
                      </>
                    </tr>
                  </thead>
                </>
              ) : (
                <>
                  <thead className="">
                    <tr className="text-start text-black bg-white border">
                      <th width="5%">#</th>
                      <>
                        <th width="10%" className="text-center">
                          Date{" "}
                        </th>
                        <th width="35%">Details</th>
                        <th width="10%" className="text-center">
                          Category
                        </th>
                        <th width="10%" className="text-center">
                          ReceivedFrom
                        </th>
                        <th width="10%" className="text-center">
                          Amount
                          <br />
                          Total:
                          {Math.round(
                            this.state.filteredaccountrevenues.reduce(
                              (a, v) => Number((a = a + Number(v.amount))),
                              0
                            ),
                            0
                          )}
                        </th>
                        <th width="10%" className="text-end">
                          Options
                        </th>
                      </>
                    </tr>
                  </thead>
                </>
              )}

              <tbody className="text-primary border">
                {this.state.filteredaccountrevenues
                  .filter((f) => {
                    if (
                      this.state.selectedCategoryId != "" &&
                      f.categoryId == this.state.selectedCategoryId
                    )
                      return true;
                    if (this.state.selectedCategoryId == "") return true;
                  })
                  .sort((a, b) => (a.created > b.created ? 1 : -1))
                  .map((accountrevenues, i) =>
                    this.state.reload === true ? (
                      <EditAccountRevenuesInline
                        index={i}
                        accountrevenues={accountrevenues}
                        categories={this.state.categories}
                        OnDeleted={this.OnDeleted}
                      ></EditAccountRevenuesInline>
                    ) : null
                  )}
              </tbody>
            </Table>
          </div>
        </div>
      </>
    );
  }
}

export class EditAccountRevenuesInline extends Component {
  static contextType = CartContext;
  constructor(props) {
    super(props);
    this.state = {
      accountrevenues: "",
      msgboxOpen: false,
      msgboxTitle: "",
      msgboxMessage: "",
      loadSpinnerOpen: false,
      msgboxOpen: false,
      msgboxTitle: "",
      msgboxMessage: "",
      editModalShow: false,
    };
  }

  ShowMessagBox = (title, message) => {
    this.setState({ msgboxOpen: true });
    this.setState({ msgboxTitle: title });
    this.setState({ msgboxMessage: message });
  };
  CloseMessagBoxCallback = () => {
    this.setState({ msgboxOpen: false });
  };

  ShowLoadSpinner = () => {
    this.setState({ loadSpinnerOpen: true });
  };
  HideLoadSpinner = () => {
    this.setState({ loadSpinnerOpen: false });
  };
  CloseMessagBoxCallback = () => {
    this.setState({ msgboxOpen: false });
  };

  OnDelete = () => {
    if (this.state.accountrevenues.id == undefined) {
      this.ShowMessagBox(
        "Information",
        "This is invalid row which can't be deleted. Press Refresh!"
      );
      return;
    }

    this.ShowLoadSpinner();
    const requestOptions = {
      method: "DELETE",
      headers: { "Content-Type": "application/json" },
    };

    fetch(
      process.env.REACT_APP_API +
        "Account/DeleteAccountRevenue/" +
        this.state.accountrevenues.id,
      requestOptions
    )
      .then((res) => {
        if (res.status != 200) {
          this.HideLoadSpinner();
          alert(
            "Not deleted. This AccountRevenues may be associated with few Products. First disassociate this accountrevenues from the Products and then try!"
          );
          return;
        }
        this.HideLoadSpinner();
        this.ShowMessagBox(
          "Status",
          "Deleted Successfully. Click Refresh Button to see the changes!"
        );
        this.props.OnDeleted();
      })
      .catch((error) => {
        this.HideLoadSpinner();
        alert("OnDelete Failed" + error);
      });
  };

  componentDidMount = () => {
    this.setState({
      accountrevenues: this.props.accountrevenues,
    });
  };
  OnEditButtonClick = () => {
    this.setState({ editModalShow: true }, () => {});
  };

  editModalClose = () => {
    this.setState({ editModalShow: false }, () => {});
  };

  GetCategoryName = (id) => {
    var result = this.props.categories.filter(
      (f) => f.id == this.state.accountrevenues.categoryId
    );
    if (result.length > 0) return result[0].name;
    return "";
  };

  render() {
    return (
      <>
        {this.state.editModalShow === true ? (
          <AccountRevenuesAddOrEditModal
            show={this.state.editModalShow}
            onHide={this.editModalClose}
            accountrevenues={this.state.accountrevenues}
            categories={this.props.categories}
            Type="Edit"
          />
        ) : (
          ""
        )}
        {this.state.loadSpinnerOpen === true ? (
          <LoadSpinner open="true"></LoadSpinner>
        ) : (
          ""
        )}
        <tr
          className="text-center align-middle text-secondary bg-white mx-5"
          style={{ fontSize: "12px" }}
        >
          {this.state.msgboxOpen === true ? (
            <MessageBox
              open={this.state.msgboxOpen}
              title={this.state.msgboxTitle}
              message={this.state.msgboxMessage}
              callback={this.CloseMessagBoxCallback}
            />
          ) : (
            ""
          )}
          <td className="text-center ">{this.props.index + 1}</td>
          <td className="text-center ">
            {this.context.GetInDateFormat(
              new Date(this.state.accountrevenues.created)
            )}
          </td>
          <td className="text-start ">{this.state.accountrevenues.details}</td>
          <td className="text-center ">
            {this.GetCategoryName(this.state.accountrevenues.categoryId)}
          </td>
          <td className="text-center ">
            {this.state.accountrevenues.receivedFrom}
          </td>
          <td className="text-end ">{this.state.accountrevenues.amount}</td>
          {window.innerWidth > 900 ? (
            <>
              <td className="text-center ">
                {this.state.accountrevenues.createdBy}
              </td>
            </>
          ) : (
            <></>
          )}

          <td className="col-md-2 text-end align-middle ">
            <div class="btn-group">
              <OverlayTrigger overlay={<Tooltip>Edit!</Tooltip>}>
                <Button
                  variant="warning"
                  onClick={(e) => {
                    this.OnEditButtonClick(e);
                  }}
                >
                  <BsFillPencilFill size="20" />
                </Button>
              </OverlayTrigger>

              <OverlayTrigger
                overlay={
                  <Tooltip>
                    Warning! This will delete this Brand Row and associated
                    Products as well.
                  </Tooltip>
                }
              >
                <Button
                  className="mx-1 "
                  variant="danger"
                  onClick={(e) => {
                    if (
                      window.confirm(
                        "Warning! This action will delete this Brand Row and associated Products as well. Are you sure you want to Delete?"
                      )
                    ) {
                      this.OnDelete(e);
                    }
                  }}
                >
                  X
                </Button>
              </OverlayTrigger>
            </div>
          </td>
        </tr>
      </>
    );
  }
}

export class AccountRevenuesAddOrEditModal extends Component {
  static contextType = CartContext;
  constructor(props) {
    super(props);

    this.state = {
      accountrevenues: {
        accountrevenuesName: "",
        manufacturerName: "",
        imgFileName: "",
        hideMe: false,
      },
      msgboxOpen: false,
      msgboxTitle: "",
      msgboxMessage: "",
      loadSpinnerOpen: false,
    };
  }

  CloseMessagBoxCallback = () => {
    this.setState({ msgboxOpen: false });
    this.props.onHide();
  };
  ShowMessagBox = (title, message) => {
    this.setState({ msgboxOpen: true });
    this.setState({ msgboxTitle: title });
    this.setState({ msgboxMessage: message });
  };
  ShowLoadSpinner = () => {
    this.setState({ loadSpinnerOpen: true });
  };
  HideLoadSpinner = () => {
    this.setState({ loadSpinnerOpen: false });
  };

  AddOrUpdateAccountRevenuesInDB = () => {
    this.ShowLoadSpinner();

    var tmpAccountRevenues = this.state.accountrevenues;
    if (this.props.Type == "Edit") {
      tmpAccountRevenues = this.props.accountrevenues;
    } else {
      tmpAccountRevenues.storeId = this.context.storeId;
    }
    tmpAccountRevenues.created = toLocalISO(tmpAccountRevenues.created);

    const requestOptions = {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify(tmpAccountRevenues),
    };

    fetch(
      process.env.REACT_APP_API + "Account/AddOrUpdateAccountRevenue/",
      requestOptions
    )
      .then((res) => {
        if (res.status == 200) {
          this.HideLoadSpinner();
          this.props.onHide();
          return;
        }
        this.HideLoadSpinner();
        alert("This AccountRevenues is already exist. try again!");
        return;
      })
      .catch((error) => {
        this.HideLoadSpinner();
        alert("Exception. Received an Exception. Try after sometime !" + error);
      });
  };

  handleSubmit = (event) => {
    event.preventDefault();
    this.AddOrUpdateAccountRevenuesInDB();
  };

  handleInputChange = (e) => {
    const { name, value } = e.target;

    switch (name.trim()) {
      case "details":
        this.state.accountrevenues.details = value;
        break;
      case "categoryId":
        this.state.accountrevenues.categoryId = value;
        break;
      case "receivedFrom":
        this.state.accountrevenues.receivedFrom = value;
        break;
      case "amount":
        this.state.accountrevenues.amount = value;
        break;
      case "createdBy":
        this.state.accountrevenues.createdBy = value;
        break;
      case "attachmentFileName":
        this.state.accountrevenues.attachmentFileName = value;
        break;
    }
    this.setState({
      accountrevenues: this.state.accountrevenues,
    });
  };

  componentDidMount() {
    if (this.props.Type == "Edit") {
      this.setState({
        accountrevenues: this.props.accountrevenues,
      });
    }
  }

  render() {
    return (
      <div className="container ">
        <Modal
          {...this.props}
          size="xl"
          aria-labelledby="contained-modal-title-vcenter"
          centered
          backdrop="static"
          keyboard={false}
          dialogClassName="AccountRevenuesModal"
        >
          {this.state.msgboxOpen === true ? (
            <MessageBox
              open={this.state.msgboxOpen}
              title={this.state.msgboxTitle}
              message={this.state.msgboxMessage}
              callback={this.CloseMessagBoxCallback}
            />
          ) : (
            ""
          )}
          {this.state.loadSpinnerOpen === true ? (
            <LoadSpinner open="true"></LoadSpinner>
          ) : (
            ""
          )}
          <Form onSubmit={this.handleSubmit}>
            <Modal.Header closeButton className="bg-warning">
              <Modal.Title id="contained-modal-title-vcenter">
                {this.props.Type == "Edit"
                  ? "Edit Account Credit(Inflow)"
                  : "Add Account Credit(Inflow)"}
              </Modal.Title>
            </Modal.Header>
            <Modal.Body className="show-grid ">
              <Row
                className="m-2 p-2 bg-light border"
                style={{ fontSize: "12pt" }}
              >
                <Col md={12}>
                  <Form.Group as={Row} className="mb-3 " controlId="">
                    <Form.Label column sm="3">
                      Payment Date
                    </Form.Label>
                    <Col sm="9">
                      <Form.Control
                        type="Date"
                        required
                        name="created"
                        value={toLocalISO(this.state.accountrevenues.created)}
                        onChange={(e) => {
                          const t = { ...this.state.accountrevenues };
                          t.created = e.target.value; // already yyyy-mm-dd format
                          this.setState({ accountrevenues: t });
                        }}
                      ></Form.Control>
                    </Col>
                  </Form.Group>
                  <Form.Group as={Row} className="mb-3 " controlId="">
                    <Form.Label column sm="3">
                      Particulars
                    </Form.Label>
                    <Col sm="9">
                      <Form.Control
                        type="text"
                        name="details"
                        maxlength="254"
                        value={this.state.accountrevenues.details}
                        required
                        placeholder=""
                        autoComplete="off"
                        onChange={(e) => this.handleInputChange(e)}
                      />
                    </Col>
                  </Form.Group>
                  <Form.Group as={Row} className="mb-3 " controlId="">
                    <Form.Label column sm="3">
                      Category
                    </Form.Label>
                    <Col sm="9">
                      <Form.Select
                        type="text"
                        name="categoryId"
                        value={this.state.accountrevenues.categoryId}
                        placeholder=""
                        required
                        autoComplete="off"
                        onChange={(e) => this.handleInputChange(e)}
                      >
                        <option value=""></option>
                        {this.props.categories.map((m) => (
                          <option value={m.id}>{m.name}</option>
                        ))}
                      </Form.Select>
                    </Col>
                  </Form.Group>
                  <Form.Group as={Row} className="mb-3 " controlId="">
                    <Form.Label column sm="3">
                      Received From
                    </Form.Label>
                    <Col sm="9">
                      <Form.Control
                        type="text"
                        name="receivedFrom"
                        maxlength="99"
                        value={this.state.accountrevenues.receivedFrom}
                        required
                        placeholder=""
                        autoComplete="off"
                        onChange={(e) => this.handleInputChange(e)}
                      />
                    </Col>
                  </Form.Group>
                  <Form.Group as={Row} className="mb-3 " controlId="">
                    <Form.Label column sm="3">
                      Amount
                    </Form.Label>
                    <Col sm="9">
                      <Form.Control
                        type="number"
                        name="amount"
                        value={this.state.accountrevenues.amount}
                        required
                        placeholder=""
                        autoComplete="off"
                        onChange={(e) => this.handleInputChange(e)}
                      />
                    </Col>
                  </Form.Group>
                  <Form.Group as={Row} className="mb-3 " controlId="">
                    <Form.Label column sm="3">
                      Created By
                    </Form.Label>
                    <Col sm="9">
                      <Form.Control
                        type="text"
                        name="createdBy"
                        value={this.state.accountrevenues.createdBy}
                        required
                        placeholder=""
                        autoComplete="off"
                        onChange={(e) => this.handleInputChange(e)}
                      />
                    </Col>
                  </Form.Group>
                </Col>
              </Row>
            </Modal.Body>
            <Modal.Footer className="bg-light">
              <Form.Group>
                <Button variant="primary" size="lg" type="submit">
                  Save
                </Button>
              </Form.Group>

              <Button variant="danger" size="lg" onClick={this.props.onHide}>
                Close
              </Button>
            </Modal.Footer>
          </Form>
        </Modal>
      </div>
    );
  }
}

function toLocalISO(dateInput) {
  if (!dateInput) return "";
  const d = dateInput instanceof Date ? dateInput : new Date(dateInput);
  if (isNaN(d.getTime())) return "";
  const yyyy = d.getFullYear();
  const mm = String(d.getMonth() + 1).padStart(2, "0");
  const dd = String(d.getDate()).padStart(2, "0");
  return `${yyyy}-${mm}-${dd}`;
}
